export default __webpack_public_path__ + "static/media/2-4-2.7440e9ed.webp";